var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"py-16"},[_c('v-row',_vm._l((_setup.cardItems),function(item){return _c('v-col',{key:item.title,attrs:{"cols":"12","md":"3"}},[_c('v-card',{staticClass:"rounded-xl",style:({
          background: item.bgColor,
        })},[_c('v-card-text',{staticClass:"d-flex flex-column",style:({ gap: '24px' })},[_c('div',{staticClass:"d-flex align-center"},[_c('v-avatar',{style:({
                boxShadow: `0px 3px 1px -2px rgba(0, 0, 0, 0.2), 
                0px 2px 2px 0px rgba(0, 0, 0, 0.14), 
                0px 1px 5px 0px rgba(0, 0, 0, 0.12)`,
              }),attrs:{"size":"40"}},[_c('v-icon',{},[_vm._v(" "+_vm._s(item.icon)+" ")])],1),_c('div',{staticClass:"ml-6 text-h6"},[_vm._v(" "+_vm._s(item.title)+" ")])],1),_c('div',{staticClass:"ml-3 text-h4 font-weight-bold"},[_vm._v(_vm._s(item.text))])])],1)],1)}),1),_c('v-row',{staticClass:"pt-10"},[_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('v-card',{staticClass:"rounded-lg",style:({
          height: _setup.chartContainerHeight,
          background: `linear-gradient(to bottom right, ${_setup.colors.grey.lighten3}, ${_setup.colors.grey.lighten5})`,
        })},[_c('v-card-text',{style:({ height: '100%' })},[_c('apexchart',{attrs:{"height":"100%","type":"bar","series":_setup.numberOfViewsPerDocumentTypeSeries,"options":{
              xaxis: {
                type: 'category',
              },
              colors: [_vm.$vuetify.theme.themes.light.primary],
              plotOptions: {
                bar: {
                  horizontal: true,
                },
              },
              title: {
                ..._setup.titleOptions,
                text: _vm.$t('numberOfDocumentViewsMsg'),
              },
            }}})],1)],1)],1),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-card',{staticClass:"rounded-lg pie-container",style:({
          height: _setup.chartContainerHeight,
          background: `linear-gradient(to bottom right, ${_setup.colors.grey.lighten3}, ${_setup.colors.grey.lighten5})`,
        })},[_c('v-card-text',{style:({ height: '100%' })},[_c('apexchart',{attrs:{"height":"100%","type":"pie","series":Object.values(_setup.documentTypesSeries),"options":{
              labels: Object.keys(_setup.documentTypesSeries),
              legend: {
                position: 'bottom',
              },
              toolbar: {
                show: true,
              },
              colors: [
                'hsl(30 20% 30%)',
                'hsl(35 30% 40%)',
                'hsl(40 40% 50%)',
                'hsl(45 50% 60%)',
                'hsl(50 60% 70%)',
              ],
              title: {
                ..._setup.titleOptions,
                text: _vm.$t('numberOfDocumentsMsg'),
              },
            }}})],1)],1)],1)],1),_c('v-row',{staticClass:"pt-10"},[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-card',{staticClass:"rounded-lg",style:({
          height: _setup.chartContainerHeight,
          background: `linear-gradient(to bottom right, ${_setup.colors.grey.lighten3}, ${_setup.colors.grey.lighten5})`,
        })},[_c('v-card-text',{style:({ height: '100%' })},[_c('apexchart',{attrs:{"height":"100%","type":"pie","series":Object.values(_setup.fileTypes),"options":{
              labels: Object.keys(_setup.fileTypes),
              legend: {
                position: 'bottom',
              },
              toolbar: {
                show: true,
              },
              colors: [
                'hsl(60 30% 30%)',
                'hsl(70 35% 35%)',
                'hsl(80 40% 40%)',
                'hsl(90 45% 45%)',
                'hsl(100 50% 50%)',
                'hsl(110 55% 55%)',
                'hsl(120 60% 60%)',
                'hsl(130 65% 65%)',
              ],
              title: {
                ..._setup.titleOptions,
                text: _vm.$t('numberOfFileTypesMsg'),
              },
            }}})],1)],1)],1),_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('v-card',{staticClass:"rounded-lg",style:({
          height: _setup.chartContainerHeight,
          background: `linear-gradient(to bottom right, ${_setup.colors.grey.lighten3}, ${_setup.colors.grey.lighten5})`,
        })},[_c('v-card-text',{style:({ height: '100%' })},[_c('apexchart',{attrs:{"height":"100%","type":"bar","series":_setup.documentsByCountry,"options":{
              xaxis: {
                type: 'category',
              },
              colors: [_vm.$vuetify.theme.themes.light.secondary],
              dataLabels: {
                enabled: false,
              },
              title: {
                ..._setup.titleOptions,
                text: _vm.$t('documentyByCountryMsg'),
              },
            }}})],1)],1)],1)],1),_c('v-row',{staticClass:"pt-10"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"rounded-xl",style:({
          height: _setup.chartContainerHeight,
          background: `linear-gradient(to bottom right, ${_setup.colors.grey.lighten3}, ${_setup.colors.grey.lighten5})`,
        })},[_c('v-card-text',{style:({ height: '100%' })},[_c('apexchart',{attrs:{"height":"100%","type":"line","options":{
              // stroke: {
              //   curve: 'smooth',
              // },
              xaxis: {
                type: 'datetime',
              },
              colors: [_vm.$vuetify.theme.themes.light.primary],
              title: {
                ..._setup.titleOptions,
                text: _vm.$t('numberOfSiteVisitsMsg'),
              },
            },"series":_setup.numberOfSiteVisitsSeries}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }